module.exports = __webpack_public_path__ + "media/img/cd-top-arrow-e8ffcff1b2d29a2d6209835f6254dbde.svg";